import { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import axios from 'axios';
import Layout from '../../components/layouts/Main';
import config from '../../config';
import StaffTable from '../../components/staff/StaffTable';
import StaffModal from '../../components/staff/StaffModal';
import { Link } from 'react-router-dom';

function StaffList() {
  const [staff, setStaff] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchStaff = async () => {
    try {
      const res = await axios.get(`${config.API_BASE_URL}/staff`);
      setStaff(res.data);
    } catch (err) {
      console.error("Error fetching staff", err);
    }
  };

  const handleAddStaff = () => {
    setShowModal(true);
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  return (
    <Layout>
    <Container fluid>
      <nav aria-label="breadcrumb" className="mb-3">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
          <li className="breadcrumb-item active">Staff</li>
        </ol>
      </nav>

      <Row className="mb-4">
        <Col><h2>Staff</h2></Col>
        <Col className="text-end">
          <Button onClick={handleAddStaff}>
            <i className="fas fa-plus me-2" /> Add Staff
          </Button>
        </Col>
      </Row>

      <StaffTable staff={staff} />
 
      <StaffModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        onStaffAdded={fetchStaff}
      />
    </Container>
    </Layout>
  );
}

export default StaffList;
